$(document).ready(function () {
    setFooterPositionFallBack();
    removeRatingsIfEmpty();

    $("#AccountSelectMenu").change(function() {
        window.location = "/account#/" + $(this).val();
    });

    $('.sf-menu').superfish({
        delay: 100, speed: 'fast'
    });

    if ($(".select-search").length) {
        const choices = new Choices('.select-search');
    }

    setTimeout(function () {
        var w = $("#LoginMenu li").outerWidth();
        $("#LoginMenu li > ul li a").outerWidth(w);

        var pw = $("#ProfileMenu li").outerWidth();
        $("#ProfileMenu li > ul li a").outerWidth(pw);

    }, 1500);

    $('#Customer-Search-Clear').click(function (event) {
        $("#Customer-Search-Wrap input[type='search']").val("");
        $("#Customer-Search-Wrap .customer-search-result").hide();
        $("#Customer-Search-Clear").hide();
    });
    $('#Customer-Search-Clear').on({ 'touchstart': function () {
            $("#Customer-Search-Wrap input[type='search']").val("");
            $("#Customer-Search-Wrap .customer-search-result").hide();
            $("#Customer-Search-Clear").hide();
        }
    });

    $('#Customer-Search-Wrap').click(function (event) {
        event.stopPropagation();
    });

    $(".form-input-phone").mask('(000) 000-0000');

    $('.animate-label input').focus(function () {
        $(this).parents('.form-group').addClass('focused');
    });
    $('.animate-label select').focus(function () {
        $(this).parents('.form-group').addClass('focused');
    });

    $('.animate-label label').click(function () {
        $(this).next("input").focus();
    });

    $('.animate-label input:not(".choices__input")').blur(function () {

        var inputValue = $(this).val();
        if (inputValue == "") {
            $(this).removeClass('filled');
            $(this).parents('.form-group').removeClass('focused');

            if ($(this).attr("required") == "required") {
                $(this).addClass("invalid-required")
                errorMsg = $(this).attr("required-error");
                $(this).next(".form-error").remove();
                $("<span class='form-error'>" + errorMsg + "</span>").insertAfter($(this));
            }

        } else {
            $(this).addClass('filled');

            if ($(this).attr("required") == "required") {
                $(this).removeClass('invalid-required');
                $(this).next(".form-error").remove();
            }
        }
    })
    $('.animate-label select').blur(function () {
        var inputValue = $(this).val();
        if (inputValue == "") {
            $(this).removeClass('filled');
            $(this).parents('.form-group').removeClass('focused');
        } else {
            $(this).addClass('filled');
        }
    })

    $('.email-validate').blur(function () {
        var emailaddress = $(this).val();
        if (!validateEmail(emailaddress)) {
            $(this).addClass("invalid-required")
            errorMsg = "Email is invalid";
            $(this).next(".form-error").remove();
            $("<span class='form-error'>" + errorMsg + "</span>").insertAfter($(this));
            passedInspection = false;
        }
        else {
            $(this).removeClass("invalid-required")
            $(this).next(".form-error").remove();
        }
    })
    
});

function SetPasswordInitialStatus() {
    $("#customer_password").parents('.form-group').addClass('focused');
    $("#customer_password").addClass('filled');
}

function removeRatingsIfEmpty() {
    setTimeout(function() {
        $( ".ruk_rating_snippet_with_border" ).each(function( index ) {
            if ($(this).is(':empty')){
                $(this).remove();
            }
        });
    }, 1500);
}   

function CheckRequiredFields() {
    var passedInspection = true; var errorMsg = "";
    $("input[required='required']").each(function (index) {
        if ($(this).val() == "") {
            $(this).addClass("invalid-required")
            errorMsg = $(this).attr("required-error");
            $(this).next(".form-error").remove();
            $("<span class='form-error'>"+errorMsg+"</span>").insertAfter($(this));
            passedInspection = false;
        }
    });
    $(".email-validate").each(function (index) {
        var emailaddress = $(this).val();
        if (!validateEmail(emailaddress)) {
            $(this).addClass("invalid-required")
            errorMsg = "Email is invalid";
            $(this).next(".form-error").remove();
            $("<span class='form-error'>" + errorMsg + "</span>").insertAfter($(this));
            passedInspection = false;
        }
        else {
            $(this).removeClass("invalid-required")
            $(this).next(".form-error").remove();
        }

    });    
    return passedInspection;
}


function validateEmail(email) {
    if (email == "") { return true; } //Pass validation if blank since it isn't required
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function setFooterPositionFallBack(){
    if($( "body" ).height() < $(document).height()){  $( "body" ).height($(document).height());  }
}
$( window ).resize(function() {
    setFooterPositionFallBack();
});


